export const getEmojiFormValue = (icon) => {
    if (icon.type === 'Emoji') {
        return {
            type: 'Emoji',
            emojiIcon: icon.emojiIcon,
        };
    }
    return {
        type: 'ImageResource',
        url: icon.url,
        // @ts-ignore
        imageResourceId: icon.id,
    };
};
export const getEmojiIcon = (icon) => {
    if (icon.type === 'Emoji') {
        return icon.emojiIcon;
    }
    return icon.url;
};
